import styled from '@emotion/styled'

export const ContainerWrapper = styled .div `
  border: 1px solid #CBCED2;
  border-radius: 5px;
  margin-block-end: 5px;
  & > div > .header {
    display: Flex;
    padding:5px 6px;
    background-color:#E0FAEE;
    font-weight: 600;
    border-bottom: 2px solid #CBCED2;

  }
`
export const NewContainer = styled.div`
  width:100%;
  display:flex;
  flex-direction: column;
  justify-content: space-between;
  border-top: 1px solid #CBCED2;
  padding: 5px ;
  & > span{
    width: 100%;
  }
  & > div{
    width:100%;
    display:flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content:space-between;
  }
  & > .header{
    padding:7px 10px;
    background-color:#E0FAEE;
    font-weight: 600;
  
  }
  
  & > div > div:nth-last-child(n+2){
    width:100%;
  }
  & > div > div:first-child,& > div.container:first-child {
    /* display:grid;
    grid-template-rows: 1fr 1fr 1fr ;
    column-gap:5px; */
    display: flex;
  flex-direction: row;
  justify-content: space-between;
  }
`
export const MasterContainer = styled.section`
  width: 100%;
    display:flex;
    flex-direction:column;
    & > div{
        width:100%;
        padding:5px 10px;
    }
    & > div:first-of-type{
        display:grid;
        grid-template-columns: 1.5fr 0.8fr 0.8fr 1fr 1.2fr;
        background-color:#F4F4F4;
        & span{
            font-weight:500;
        }
    }

    & > div:nth-of-type(2) > div{
        display:grid;
        grid-template-columns: 1.5fr 0.8fr 0.8fr 1fr 1.2fr;
    }
`
export const WContainer = styled.section`
  width: 100%;
    display:flex;
    flex-direction:column;
    & > div{
        width:100%;
        padding:5px 10px;
    }
    & > div:first-of-type{
        display:grid;
        grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 0.1fr 0.1fr 1fr 0.1fr 1fr 0.1fr 1fr;
        background-color:#F4F4F4;
        & span{
            font-weight:500;
        }
        /* & > div:last-of-type :last-child{
          display:grid;
        grid-template-columns: 1.2fr 0.8fr;
        background-color:#F4F4F4;

        } */
    }

    & > div:nth-of-type(2) > div{
        display:grid;
        grid-template-columns: 1.2fr 0.8fr 0.8fr 1fr 1fr 1.5fr;
    }
`

export const NotAvailable = styled.div`
  padding: 10px 20px;
`

export const StyledLink = styled.a`
    margin-bottom: 5px;
    width:100%;
    padding:10px;
    display: flex;
    gap:10px;
    border-radius: 5px;
    border:1px dashed #D0CECE;
    text-decoration:none;
    color:#222;
    cursor: pointer;
    & > span{
      display: flex;
      justify-content:center;
      align-items: center;
      font-size:25px;
    }
    & > div{
      display: flex;
      flex-direction: column;
      gap:5px;
    }
    & > div > span:first-of-type{
      font-size: 13px;
    }
    & > div > span:last-of-type{
      color:#7B7A7A;
    }
`;

const EachQualificationContainer = styled.div`
  width:100%;
  display:flex;
  flex-wrap:wrap;
  justify-content: space-between;
  row-gap:20px;
  column-gap:10px;
  & > span{
    width: 100%;

  }
  & > span > span{
      padding:7px 8px;
      background-color:#E0FAEE;
      font-weight: 600;
  }
  & > div{
    width:40%;    
  }
`